<template>
  <div>
    <div v-if="hasPermission">
      <slot />
    </div>
    <div v-else>
      <b-loading v-if="!forbidden" :active.sync="isLoading" :is-full-page="true" :can-cancel="false" />
      <div v-else>
        <div class="modal-card has-text-centered" style="display: flex; align-items: center">
          <p class="title">403 Forbidden</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, functions } from "@/firebase";
export default {
  name: "SurveyPermissions",
  props: {
    survey: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      moderationPw: null,
      hasPermission: false,
      isLoading: true,
      forbidden: false,
    };
  },
  watch: {
    survey: {
      immediate: true,
      async handler() {
        if (!this.hasPermission && this.survey != null && Object.keys(this.survey).length > 0) {
          this.isLoading = true;
          try {
            let data = await functions.httpsCallable("CheckSurveyPw")({
              surveyId: this.survey.id,
              moderationPw: this.$route.params.moderationPw,
            });
            if (data.data) {
              this.hasPermission = true;
              this.isLoading = false;
            } else {
              throw "error";
            }
          } catch (error) {
            this.forbidden = true;
            //this.$router.push({name: 'Home'})
          }
        }
      },
    },
  },
  mounted() {
    auth.onAuthStateChanged(async (user) => {
      if (!user) {
        auth.signInAnonymously();
      }
    });
  },
};
</script>

<style></style>
